import { useState, type FormEvent } from 'react';
import { useSession } from './SessionContext';
import { ApiError } from '../api';
import './LoginScreen.css';

export function LoginScreen() {
  const { login } = useSession();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(password);
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : 'Something went wrong.',
      );
      setPassword('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={onSubmit}>
        <div className="login__logo" aria-hidden>
          ◎
        </div>
        <h1 className="login__title">Loulou Pictures</h1>
        <p className="login__sub">Enter the password to continue.</p>

        <input
          type="password"
          className="login__input"
          placeholder="Password"
          value={password}
          autoFocus
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
          disabled={busy}
        />

        {error && (
          <p className="login__error" role="alert">
            {error}
          </p>
        )}

        <button
          type="submit"
          className="login__btn"
          disabled={busy || !password}
        >
          {busy ? 'Checking…' : 'Unlock'}
        </button>
      </form>
    </div>
  );
}
